import request from '@/router/axios'
import {VUE_APP_TENANT_CODE, VUE_APP_API_CONTEXT_PATH} from '@/utils/env'

const baseUrl = VUE_APP_API_CONTEXT_PATH

export function login(username, password, code, uuid, type) {
  return request({
    url: baseUrl + (type === 0 ? '/auth/login' : '/auth/personCodeLogin'),
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: { username, password, code, uuid, type, 'loginType': 1}
  })
}

export function register(data) {
  return request({
    url: baseUrl + '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}
export function getCode(phone) {
  return
  return request({
    url: baseUrl + '/auth/appCaptcha/' + phone,
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

export function getUserInfo(token) {
  return request({
    url: baseUrl + '/system/tPerson/getInfo',
    method: 'get'
  })
}
export function logout() {
  return request({
    url: baseUrl + '/auth/logout',
    method: 'delete'
  })
}
export function refreshToken(token) {
  return request({
    url: baseUrl + '/auth/refresh',
    headers: {
      'Authorization': token
    },
    method: 'get',
    params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/login.js